import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69cf29a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-bar" }

import Menu from '@/views/layout/Menu/index.vue'
import { menuList } from '@/router/routes';
import { useRoute } from 'vue-router'
import { useCommon } from '@/store/useCommon'
import {computed} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();

const storeCommon = useCommon()

// 菜单是否折叠
const isCollapse = computed(() => storeCommon.isCollapse)


const handleOpen = (key: string, keyPath: string[]) => {
  // console.log(key, keyPath)
}
const handleClose = (key: string, keyPath: string[]) => {
  // console.log(key, keyPath)
}


const activeMenu = computed(() => {
  const { meta, path } = route;
  // if set path, the sidebar will highlight the path you set
  if (meta.activeMenu) {
    return meta.activeMenu;
  }
  return path;
})

return (_ctx: any,_cache: any) => {
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_scrollbar, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          style: {"height":"100%"},
          "default-active": activeMenu.value,
          class: "el-menu-vertical-demo",
          onOpen: handleOpen,
          onClose: handleClose,
          "background-color": "#36373A",
          "text-color": "#fff",
          "menu-trigger": "click",
          collapse: isCollapse.value,
          router: ""
        }, {
          default: _withCtx(() => [
            _createVNode(Menu, { "menu-list": _unref(menuList) }, null, 8, ["menu-list"])
          ]),
          _: 1
        }, 8, ["default-active", "collapse"])
      ]),
      _: 1
    })
  ]))
}
}

})